import React from "react";

interface TableCellProps {
  id: string;
  rowIndex: number;
  onClick?: () => void;
  children: React.ReactNode;
}

const TableCell: React.FC<TableCellProps> = ({ id, rowIndex, onClick, children }) => (
  <td
    id={`${id}-${rowIndex}`}
    className="tw-py-2 tw-px-6 tw-border-b tw-border-[#F4F5F7]"
    onClick={onClick}
  >
    {children}
  </td>
);

export default TableCell;